import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as reportsActions from '../../actions/Reports';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import FilterDropDown from '../../components/FilterDropDown';
import AutoComplete from 'react-autocomplete';
import LocaleComponent from '../../LocaleComponent';
import { costFormatter, linkFormatter, checkFormatter, statusFormatter } from '../Formatter';

class Dashboard extends LocaleComponent {

  constructor(props) {
    super(props);

    this.state = {
      first: false,
      second: false,
      productFilter: this._all,
      statusFilter: this._all,
      searchText: '',
      budgetSortOrder: '',
    };
  }

  componentDidMount() {
    this.props.clearMcId();
    this.props.getCustomers();
  }

  onProductFilterClick = productFilter => {
    this.setState({productFilter})
  };

  onStatusFilterClick = statusFilter => {
    this.setState({statusFilter});
  };

  onSearchTextChanged = e => {
    const searchText = e.target.value;
    this.setState({searchText});
    this.props.queryId(searchText);
  };

  renderCustomHeader() {
    const {budgetSortOrder} = this.state;

    const iconClass =
      budgetSortOrder === 'asc' ? 'fa fa-chevron-down' :
      budgetSortOrder === 'desc' ? 'fa fa-chevron-up' :
      '';

    const onClick = () => {
      let { budgetSortOrder } = this.state;

      if (budgetSortOrder === '' || budgetSortOrder === 'desc') {
        budgetSortOrder = 'asc';
      } else if (budgetSortOrder === 'asc') {
        budgetSortOrder = 'desc';
      }

      this.setState({budgetSortOrder})
    };

    return (
      <div onClick={onClick}>
        {this.localeMessage('Budget')}&nbsp; <i className={iconClass} />
      </div>
    )
  }

  onSelectGlobalSearch(text) {
    const { queryResult, getCampaigns } = this.props;
    const { searchText } = this.state;

    const result = queryResult.filter(item => item.Description === text);
    if (result.length > 0) {
      const i = result[0];
      getCampaigns(i.MCID);
      if (i.Type === 'Campaign') {
        this.props.history.push(`/campaigns?mcId=${i.MCID}`);
      } else if (i.Type === 'Ad_ID') {
        this.props.history.push(`/ads?mcId=${i.MCID}&searchText=${searchText}`);
      } else if (i.Type === 'AdGroup_ID') {
        this.props.history.push(`/adgroups?mcId=${i.MCID}&searchText=${searchText}`);
      }
    }
  }

  render() {
    const { customers, queryResult } = this.props;
    const { productFilter, statusFilter, searchText } = this.state;

    const availableProducts = customers ?
      customers.reduce((prev, item) => {
        if (prev.indexOf(item.Product) === -1) {
          prev.push(item.Product);
        }
        return prev;
      }, [this._all]) : [this._all];

    const availableStatus = customers ?
      customers.reduce((prev, item) => {
        if (prev.indexOf(item.status) === -1) {
          prev.push(item.status);
        }
        return prev;
      }, [this._all]) : [this._all];

    const data = customers.filter((item) => {
      return ((productFilter !== this._all) ? (item.Product.toString() === productFilter) : true) &&
        ((statusFilter !== this._all) ? (item.status.toString() === statusFilter) : true);
    });

    const MerchantTable = (
      <BootstrapTable data={ data }>
        <TableHeaderColumn
          width='80'
          dataField='MCID'
          isKey dataFormat={linkFormatter}
          filter={ { type: 'TextFilter', placeholder: this.localeMessage('Please enter a value') } }
        >
          {this.localeMessage('MCID')}
        </TableHeaderColumn>
        <TableHeaderColumn
          width='100'
          dataField='Product'
        >
          {this.localeMessage('Product')}
        </TableHeaderColumn>
        <TableHeaderColumn
          width='300'
          dataField='campaign_name'
          filter={ { type: 'TextFilter', placeholder: this.localeMessage('Please enter a value') } }>
          {this.localeMessage('Name')}
        </TableHeaderColumn>
        <TableHeaderColumn
          width='300'
          dataField='advertiser_name'
          filter={ { type: 'TextFilter', placeholder: this.localeMessage('Please enter a value') } }>
          {this.localeMessage('Advertiser')}
        </TableHeaderColumn>
        <TableHeaderColumn width='100' dataField='Cycle'>
          {this.localeMessage('Cycle')}
        </TableHeaderColumn>
        <TableHeaderColumn width='150' dataField='budget' dataSort dataFormat={costFormatter}>
          {this.renderCustomHeader()}
        </TableHeaderColumn>
        <TableHeaderColumn width='100' dataField='Devices' dataFormat={checkFormatter}>
          {this.localeMessage('Devices')}
        </TableHeaderColumn>
        <TableHeaderColumn width='100' dataField='Schedules' dataFormat={checkFormatter}>
          {this.localeMessage('Schedules')}
        </TableHeaderColumn>
        <TableHeaderColumn width='100' dataField='Extensions' dataFormat={checkFormatter}>
          {this.localeMessage('Extensions')}
        </TableHeaderColumn>
        <TableHeaderColumn width='100' dataField='status' dataFormat={statusFormatter}>
          {this.localeMessage('STATUS')}
        </TableHeaderColumn>
      </BootstrapTable>
    );

    return (
      <div className="animated fadeIn">
        <div className="row">
          <div className="col-lg-6">
            <div className="form-group">
              <div className="input-group">
                <div className="input-group-btn">
                  <span className="input-group-addon">
                    <i className="fa fa-filter" /> &nbsp;{this.localeMessage('Filter')}
                  </span>
                  <FilterDropDown title={this.localeMessage('PRODUCT')}
                                  data={availableProducts}
                                  filter={productFilter}
                                  onClick={this.onProductFilterClick}
                  />
                  <FilterDropDown title={this.localeMessage('STATUS')}
                                  data={availableStatus}
                                  filter={statusFilter}
                                  onClick={this.onStatusFilterClick}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="form-group">
              <div className="input-group">
                <span className="input-group-addon" style={{backgroundColor: 'green', color: 'white'}}>
                  <i className="fa fa-search" /> &nbsp;{this.localeMessage('ID Search')}
                </span>
                <div className="form-control filter text-filter">
                  <AutoComplete
                    getItemValue={(item) => item.Description}
                    items={queryResult}
                    renderItem={(item, isHighlighted) =>
                      <div style={{ background: isHighlighted ? 'lightgray' : 'white' }}>
                        {item.Description}
                      </div>
                    }
                    value={searchText}
                    onChange={this.onSearchTextChanged}
                    onSelect={(val) => this.onSelectGlobalSearch(val)}
                    style={{width: '100%', height: '100%'}}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12">
            <div style={{width: '100%'}}>
              {data && MerchantTable}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

class DashboardContainer extends Component {
  render() {
    return <Dashboard
      {...this.props}
      {...bindActionCreators({
        ...reportsActions,
      }, this.props.dispatch)} />;
  }
}

DashboardContainer = connect(state => ({
  customers: state.reports.get('customers'),
  queryResult: state.reports.get('queryResult'),
  selectedLocale: state.reports.get('selectedLocale'),
  translations: state.reports.get('translations'),
}))(DashboardContainer);

export default DashboardContainer;



// WEBPACK FOOTER //
// ./src/views/Dashboard/Dashboard.js